import React, { useRef, useState, useEffect } from "react";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

//librerias de microsoft
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../microsoft/authConfig";

import FirstGraph from "../components/graphs/FirstGraph";
import SecondGraph from "../components/graphs/SecondGraph";
import ThirdGraph from "../components/graphs/ThirdGraph";
import FourthGraph from "../components/graphs/FourthGraph";
import FifthGraph from "../components/graphs/FifthGraph";
import SixthGraph from "../components/graphs/SixthGraph";
import SeventhGraph from "../components/graphs/SeventhGraph";
import EighthGraph from "../components/graphs/EighthGraph";
import Nineth from "../components/graphs/Nineth";
import TenthGraph from "../components/graphs/TenthGraph";
import EleventhGraph from "../components/graphs/EleventhGraph";
import TwelvethGraph from "../components/graphs/TwelvethGraph";
import { TabSelected } from "../SXStyle";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const [isMounted, setIsMounted] = useState(false);

  //identifica si el tab esta seleccionado - util para las graficas
  useEffect(() => {
    if (value === index) {
      setIsMounted(true);
    }
  }, [value, index]);

  return (
    <div
      role="tabpanel"
      style={{
        display: value !== index ? 'none' : 'block',
        width: '100%',
        height: '100%'
      }}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {isMounted && value === index && (
        <Box sx={{ p: 3, width: '100%', height: '100%' }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function Graphs() {
  const [value, setValue] = useState(0); //valor del tab

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //listado de excel
  const [dataExcel, setDatosExcel] = useState([]);

  //efecto de loading
  const [openLoader, setOpenLoader] = useState(true);

  //de microsoft
  const { instance, accounts } = useMsal();

  //carga el listado
  useEffect(() => {
    loginAndFetchExcel();
  }, [instance, accounts]);

  //carga el listado de excel
  const loginAndFetchExcel = async () => {
    try {
      let account = instance.getActiveAccount();
  
      // Inicia sesión si no hay cuenta activa
      if (accounts.length === 0) {
        const loginResponse = await instance.loginPopup(loginRequest);
        account = loginResponse.account;
        console.log("Logueado como :", loginResponse.account.username);
  
        // Lo establece como cuenta activa
        instance.setActiveAccount(account);
      }
  
      //Obtiene el token
      const tokenResponse = await instance.acquireTokenSilent({
        ...loginRequest,
        account: account,
      });
  
      const accessToken = tokenResponse.accessToken;
  
      // Sitio de excel
      const response = await fetch(
        "https://graph.microsoft.com/v1.0/me/drive/root:/Graficas v2.xlsx:/workbook/worksheets('Hoja1')/usedRange",
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
  
      const data = await response.json();
      const allRows = data.values;
  
      // Elimina los encabezados del excel:
      const excelRows = allRows.slice(1);
      setDatosExcel(excelRows);
        
    } catch (err) {
      console.error(err);
    }
  };
  

  return (
    <Box
      className="min-h-[calc(82vh)] w-[99%] flex rounded-lg shadow-xl  bg-blanco border-gray-700"
    >
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: 'divider' }}
        TabIndicatorProps={{
        sx: {
          backgroundColor: '#cb9636', // o cualquier color
          width: 3, // ancho del indicador
        },
      }}
      >
        <Tab label="JUL ONZAS" {...a11yProps(0)} sx={TabSelected}/>
        <Tab label="JUL TONELADAS)" {...a11yProps(1)} sx={TabSelected}/>
        <Tab label="JUN AUEQ ONZAS" {...a11yProps(2)} sx={TabSelected}/>
        <Tab label="JUN TONELADAS" {...a11yProps(3)} sx={TabSelected}/>
        <Tab label="MAY AUEQ ONZAS" {...a11yProps(4)} sx={TabSelected}/>
        <Tab label="MAY TONELADAS" {...a11yProps(5)} sx={TabSelected}/>
        <Tab label="ABR AUEQ ONZAS" {...a11yProps(6)} sx={TabSelected}/>
        <Tab label="ABR TONELADAS" {...a11yProps(7)} sx={TabSelected}/>
        <Tab label="MAR ONZAS" {...a11yProps(8)} sx={TabSelected}/>
        <Tab label="MAR TONELADAS" {...a11yProps(9)} sx={TabSelected}/>
        <Tab label="FEB ONZAS" {...a11yProps(10)} sx={TabSelected}/>
        <Tab label="FEB TONELADAS" {...a11yProps(11)} sx={TabSelected}/>
      </Tabs>
            
      <TabPanel value={value} index={0}>
        <FirstGraph
          visible={value === 0}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        /> 
      </TabPanel>

      <TabPanel value={value} index={1}>
        <SecondGraph 
          visible={value === 0}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>

      <TabPanel value={value} index={2}>
        <ThirdGraph 
          visible={value === 0}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>

      <TabPanel value={value} index={3}>
        <FourthGraph 
          visible={value === 0}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>


      <TabPanel value={value} index={4}>
        <FifthGraph 
          visible={value === 0}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>

      <TabPanel value={value} index={5}>
        <SixthGraph
          visible={value === 0}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>
      
      <TabPanel value={value} index={6}>
        <SeventhGraph
          visible={value === 0}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>

      <TabPanel value={value} index={7}>
        <EighthGraph
          visible={value === 0}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>

      <TabPanel value={value} index={8}>
        <Nineth
          visible={value === 0}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>

      <TabPanel value={value} index={9}>
        <TenthGraph
          visible={value === 0}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>


       <TabPanel value={value} index={10}>
        <EleventhGraph
          visible={value === 0}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>


      <TabPanel value={value} index={11}>
        <TwelvethGraph
          visible={value === 0}
          dataExcel={dataExcel}
          openLoader={openLoader}
          setOpenLoader={setOpenLoader}
        />
      </TabPanel>


    </Box>
  );
}